module.exports = __webpack_public_path__ + "webfonts/lg.svg";


//////////////////
// WEBPACK FOOTER
// ../~/lightgallery/src/fonts/lg.svg?n1z373
// module id = 535
// module chunks = 68 69